import { computed, ref } from 'vue';

export function useTrainingListSelection() {
  const selectedIds = ref(new Set<number>());

  const selectedCount = computed(() => selectedIds.value.size);
  const hasSelected = computed(() => selectedIds.value.size > 0);
  const selectedIdList = computed(() => [...selectedIds.value]);

  function isSelected(id: number): boolean {
    return selectedIds.value.has(id);
  }

  function toggle(id: number): void {
    const next = new Set(selectedIds.value);
    if (next.has(id)) {
      next.delete(id);
    } else {
      next.add(id);
    }
    selectedIds.value = next;
  }

  function isAllSelected(pageIds: number[]): boolean {
    return pageIds.length > 0 && pageIds.every((id) => selectedIds.value.has(id));
  }

  function isPartiallySelected(pageIds: number[]): boolean {
    if (pageIds.length === 0) return false;
    const selectedOnPage = pageIds.filter((id) => selectedIds.value.has(id)).length;
    return selectedOnPage > 0 && selectedOnPage < pageIds.length;
  }

  function toggleAll(pageIds: number[]): void {
    if (pageIds.length === 0) return;

    const next = new Set(selectedIds.value);
    if (isAllSelected(pageIds)) {
      pageIds.forEach((id) => next.delete(id));
    } else {
      pageIds.forEach((id) => next.add(id));
    }
    selectedIds.value = next;
  }

  function remove(ids: number[]): void {
    const next = new Set(selectedIds.value);
    ids.forEach((id) => next.delete(id));
    selectedIds.value = next;
  }

  function clear(): void {
    selectedIds.value = new Set();
  }

  return {
    selectedIds,
    selectedIdList,
    selectedCount,
    hasSelected,
    isSelected,
    toggle,
    toggleAll,
    isAllSelected,
    isPartiallySelected,
    remove,
    clear,
  };
}
